import { colors } from '../../colors';
var jumplink = {
  bgColor: colors.white,
  borderColor: colors.overcast,
  linkColor: colors.red
};
export default jumplink;